// Адреса — только относительные, схема — только выведенная из страницы.
//
// Хардкод `ws://` — ровно та строчка, которую потом ищут полчаса: страница,
// открытая по https, обязана ходить по wss, иначе браузер заблокирует
// соединение как смешанный контент, и сообщение об этом будет невнятным.

/** Полный адрес WebSocket'а по относительному пути. */
export function wsUrl(path: string, location: { protocol: string; host: string }): string {
  const scheme = location.protocol === "https:" ? "wss:" : "ws:";
  return `${scheme}//${location.host}${path}`;
}
